class MAskQuestion extends HTMLElement {
  constructor() {
    super()
    this.selectors = {
      openButton: '[data-open-ask-question]',
      content: '.m-form-ask-question',
      container: '.m-product-addon',
      formSuccess: '.form-ask__success'
    }
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors,this);
    this.container = document.querySelector(this.selectors.container);
    this.colorScheme = this.domNodes.content.dataset.colorScheme;
    if (this.domNodes.content && this.domNodes.content.innerHTML) {
      this.content = this.domNodes.content.innerHTML;
      this.init();
    }
  }

  init() {
    this.showSuccessMessage();
    this.modal = new MinimogTheme.Modal();
    // Wrap the public modal lifecycle; never edit vendor.js for Marina customizations.
    const originalClose = this.modal.close.bind(this.modal);
    this.modal.close = (...args) => {
      this.releaseFocus?.();
      this.releaseFocus = null;
      return originalClose(...args);
    };
    addEventDelegate({
      selector: this.selectors.openButton,
      handler: (e) => {
        if (!this.contains(e.target)) return;
        e.preventDefault()
        if (this.content) {
          const html = document.createElement("DIV");
          html.innerHTML = this.content;
          MAskQuestion.instanceCount = (MAskQuestion.instanceCount || 0) + 1;
          html.querySelector('form').id = `marina-inquiry-${MAskQuestion.instanceCount}`;
          this.modal.appendChild(html);
          this.modal.setWidth('500px');
          this.modal.setSizes(`m-form-ask-question m-gradient ${this.colorScheme}`);
          this.container.classList.remove('m\:hidden');
          this.modal.open();
          const dialog = this.modal.modalContent;
          dialog.setAttribute('aria-label', html.querySelector('h3').textContent);
          const closeButton = this.modal.modal.querySelector('.m-modal--close');
          closeButton?.setAttribute('aria-label', this.dataset.closeLabel || 'Close');
          this.releaseFocus = window.MarinaA11y.openDialog(dialog, {
            trigger: e.target.closest('[data-open-ask-question]'),
            close: () => this.modal.close(),
            initialFocus: html.querySelector('input:not([type="hidden"])'),
          });
        }
      }
    })
  }
  disconnectedCallback() {
    this.releaseFocus?.();
  }
  showSuccessMessage() {
    const successMessage = this.container.querySelector(this.selectors.formSuccess);
    if (successMessage) {
      MinimogTheme.Notification.show({
        target: document.body,
        method: 'appendChild',
        type: 'success',
        message: successMessage.dataset.message,
        delay: 2000,
        sticky: true
      })

      setTimeout(() => {
        const url = window.location.origin + window.location.pathname
        window.history.replaceState({},document.title, url)
      }, 2500)
    }
  }
}
customElements.define('m-ask-question', MAskQuestion)
